import React, { useState, useEffect } from "react";
import axios from "axios";
import apiUrl from "../../environment/Api";
import "../../assets/css/Studentinvoice.css";
import { useParams, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { ToWords } from "to-words";
import html2pdf from "html2pdf.js";

function Studentinvoice() {
  const [responseData, setResponseData] = useState({});
  const [formattedDate, setFormattedDate] = useState("");
  const [formatdate, setformatdate] = useState("");
  const [words, setWords] = useState("");
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const isDownload = location.pathname.includes('/Studentdownload/');

  useEffect(() => {
    fetchData();

    if (isDownload) {
      const pdfTimeout = setTimeout(() => {
        generatePDF();
      }, 2000); // Increased timeout to ensure everything loads

      return () => clearTimeout(pdfTimeout);
    } else {
      const printTimeout = setTimeout(() => {
        window.print();
      }, 1000);

      const redirectTimeout = setTimeout(() => {
        navigate("/Invoice");
      }, 2000);

      return () => {
        clearTimeout(printTimeout);
        clearTimeout(redirectTimeout);
      };
    }
  }, [id, navigate, isDownload]);

  const fetchData = async () => {
    try {
      console.log("invoice_no", id);
      const response = await axios.get(apiUrl + `/invoice_join/${id}`);
      console.log("Invoice data:", response.data);
      setResponseData(response.data);

      const formattedDate = new Date(response.data.date).toLocaleDateString();
      setFormattedDate(formattedDate);

      const formatdate = new Date(
        response.data.next_due_date
      ).toLocaleDateString();
      setformatdate(formatdate);

      if (response.data.nettotal) {
        const amountInWords = toWords.convert(response.data.nettotal);
        setWords(amountInWords);
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const toWords = new ToWords({
    localeCode: "en-IN",
    converterOptions: {
      currency: true,
      ignoreDecimal: false,
      ignoreZeroCurrency: false,
      doNotAddOnly: false,
      currencyOptions: {
        name: "Rupees",
        plural: "Rupees",
        symbol: "₹",
        fractionalUnit: {
          name: "Paisa",
          plural: "Paisa",
          symbol: "",
        },
      },
    },
  });

  const generatePDF = async () => {
    try {
      const element = document.getElementById('invoice-content');

      if (!element) {
        console.error("Invoice content not found");
        navigate("/Invoice");
        return;
      }

      const opt = {
        margin: 5, // Small uniform margin
        filename: `Invoice_${responseData.invoice_no || id}.pdf`,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: {
          scale: 2.5, // Balanced scale for quality and size
          useCORS: true,
          letterRendering: true,
          logging: false,
          windowWidth: 595, // A5 width in pixels at 72 DPI
          windowHeight: 842, // A5 height in pixels at 72 DPI
          backgroundColor: '#ffffff',
          removeContainer: true
        },
        jsPDF: {
          unit: 'mm',
          format: [148, 210], // Exact A5 dimensions
          orientation: 'portrait',
          compress: true
        },
        pagebreak: {
          mode: ['avoid-all'],
          before: '.page-break-before',
          after: '.page-break-after',
          avoid: 'tr'
        }
      };

      await html2pdf().set(opt).from(element).save();

      setTimeout(() => {
        navigate("/Invoice");
      }, 500);
    } catch (error) {
      console.error("Error generating PDF:", error);
      navigate("/Invoice");
    }
  };

  return (
    <>
      <div id="invoice-content" className={isDownload ? "pdf-mode" : ""}>
        <table className="fourth_table">
          <thead className="table_head_four">
            <tr className="gap">
              <br></br>
              <th className="text-center text-danger">INVOICE</th>
            </tr>
          </thead>
        </table>

        <table className="first_table">
          <tbody>
            <tr style={{ padding: "100px" }}>
              <td className="small_letter" style={{ paddingTop: "7px" }}>
                Branch Code
              </td>
              <td className="small_letter" style={{ paddingTop: "7px" }}>
                : {responseData.branch_id}
              </td>
              <td rowSpan={3}>
                <div style={{ width: "100%" }}>
                  <img
                    alt="invoice logo"
                    crossOrigin="anonymous"
                    style={{
                      width: "143%",
                      height: "50px",
                      marginLeft: "28px",
                      marginTop: "30px",
                    }}
                    src={require("../../assets/img/scimitar logo slogan.png")}
                  />
                </div>
              </td>
            </tr>

            <tr>
              <td className="small_letter" style={{ paddingTop: "5px" }}>
                Address{" "}
              </td>
              <td className="small_letter" style={{ paddingTop: "5px" }}>
                :{" "}
                {Array.isArray(responseData.branch_info) &&
                  responseData.branch_info[0]?.address}
              </td>
            </tr>

            <tr>
              <td className="small_letter" style={{ paddingTop: "5px" }}>
                Phone No{" "}
              </td>
              <td className="small_letter" style={{ paddingTop: "5px" }}>
                :{" "}
                {Array.isArray(responseData.branch_info) &&
                  responseData.branch_info[0]?.phone_no}{" "}
              </td>
            </tr>

            <tr className="second_row">
              <td className="small_letter" style={{ paddingBottom: "7px" }}>
                Email ID{" "}
              </td>
              <td className="small_letter">
                <p
                  style={{
                    width: "20%",
                    paddingTop: "9px",
                    fontSize: "12px",
                  }}
                  className="small_letter"
                >
                  :
                  {Array.isArray(responseData.branch_info) &&
                    responseData.branch_info[0]?.email_id}
                </p>{" "}
              </td>
            </tr>

            <tr className="third_row">
              <td colSpan={2} className="small_letter">
                <b>Student Details:</b>
              </td>
              <td className="small_letter">
                <b>Invoice Details:</b>
              </td>
            </tr>

            <tr className="fourth_row">
              <td className="left_line small_letter" style={{ width: "30%" }}>
                Student Name{" "}
              </td>
              <td className="left_line small_letter">{responseData.name}</td>
              <td className="left_line small_letter" style={{ width: "10%" }}>
                Student ID{" "}
              </td>
              <td className="left_line small_letter" style={{ width: "22%" }}>
                {" "}
                {responseData.student_info?.roll_no}
              </td>
            </tr>

            <tr className="fifth_row">
              <td className="left_line small_letter">Enroll No </td>
              <td className="left_line small_letter">
                {responseData.student_info?.register_no}
              </td>
              <td className="left_line small_letter">Invoice No </td>
              <td className="left_line small_letter">
                {responseData.invoice_no}
              </td>
            </tr>

            <tr className="sixth_row">
              <td rowSpan={2} className="small_letter">
                Address
              </td>
              <td rowSpan={2} className="left_line small_letter">
                {responseData.student_info?.permanent_address}
              </td>
              <td className="left_line small_letter">Date </td>
              <td className="left_line small_letter">{formattedDate}</td>
            </tr>

            <tr className="seventh_row">
              <td className="left_line small_letter">Total Fee: </td>
              <td className="left_line small_letter">
                {responseData.nettotal}
              </td>
            </tr>

            <tr className="eight_row">
              <td className="left_line small_letter">Phone No </td>
              <td className="left_line small_letter">{responseData.mobile}</td>
              <td className="left_line small_letter">Paid Till Date </td>
              <td className="left_line small_letter">
                {responseData.paid_till_date}
              </td>
            </tr>

            <tr className="nineth_row">
              <td className="left_line small_letter">Email ID </td>
              <td className="left_line small_letter">{responseData.email}</td>
              <td className="left_line small_letter">Pending Fee </td>
              <td className="left_line small_letter">{responseData.balance}</td>
            </tr>

            <tr className="tenth_row">
              <td className="left_line small_letter">Total Hours </td>
              <td className="left_line small_letter">
                {responseData.student_info?.duraction}
              </td>
              <td className="left_line small_letter">Payment Due Date </td>
              <td className="left_line small_letter">{formattedDate} </td>
            </tr>

            <tr className="eleventh_row">
              <td className="left_line small_letter">Course Purpose </td>
              <td className="left_line small_letter">
                {responseData.student_info?.purpose_enquiry_lead}
              </td>
              <td className="left_line small_letter">Next Due Date </td>
              <td className="left_line small_letter">{formatdate}</td>
            </tr>

            <tr className="tweleveth_row">
              <td colSpan={2} className="small_letter">
                <b>Payment Made By:</b>
              </td>
            </tr>

            <tr className="sixth_row">
              <td className="left_line small_letter">Person Name </td>
              <td className="left_line small_letter">
                {responseData.person_name}
              </td>
              <td
                rowSpan={2}
                className="left_line small_letter"
                style={{ width: "32%", whiteSpace: "nowrap", borderBottom: "none" }}
              >
                RelationShip
              </td>
              <td
                rowSpan={2}
                className="left_line small_letter"
                style={{ whiteSpace: "nowrap", borderBottom: "none" }}
              >
                {responseData.paid_by}
              </td>
            </tr>

            <tr className="seventh_row">
              <td className="left_line small_letter">Contact </td>
              <td className="left_line small_letter">{responseData.contact}</td>
            </tr>
          </tbody>
        </table>

        <table className="second_table">
          <thead className="table_head_one">
            <tr className="">
              <th
                colSpan={1}
                className="small_letter text-center"
                style={{ borderLeft: "1px solid #000" }}
              >
                <b>S.No</b>
              </th>
              <th
                className="small_letter left_line text-center"
                style={{ width: "45%" }}
              >
                <b>Description</b>
              </th>
              <th
                className="small_letter left_line text-center"
                style={{ width: "35%", borderRight: "1px solid #000" }}
              >
                <b>Payment Made</b>
              </th>
            </tr>
          </thead>
          <tbody className="table_head_one">
            <tr className="">
              <td
                colSpan={1}
                className="small_letter text-center"
                style={{ borderLeft: "1px solid #000" }}
              >
                1
              </td>
              <td className="small_letter left_line text-center">
                {responseData.dependent}
              </td>
              <td
                className="small_letter left_line text-center"
                style={{ borderRight: "1px solid #000" }}
              >
                {responseData.paytype}
              </td>
            </tr>
          </tbody>
        </table>

        <table className="second_table">
          <tbody>
            <tr>
              <td
                rowSpan={3}
                className="small_letter"
                style={{ borderLeft: "1px solid #000", width: "50%" }}
              >
                Amount In Words: {words}
              </td>
              <td
                className="left_line small_letter text-center Under"
                style={{ width: "25%", whiteSpace: "nowrap" }}
              >
                Sub Total:{" "}
              </td>
              <td
                className="left_line small_letter text-center Under"
                style={{ width: "25%", whiteSpace: "nowrap" }}
              >
                {responseData.subtotal}
              </td>
            </tr>

            <tr>
              <td
                className="left_line small_letter text-center Under"
                style={{ width: "25%", whiteSpace: "nowrap" }}
              >
                Discount
              </td>
              <td
                className="left_line small_letter text-center Under"
                style={{ whiteSpace: "nowrap" }}
              >
                {responseData.discount}
              </td>
            </tr>
            <tr>
              <td
                className="left_line small_letter text-center"
                style={{ whiteSpace: "nowrap" }}
              >
                <b>Final Amount:</b>{" "}
              </td>
              <td
                className="left_line small_letter text-center"
                style={{ borderRight: "1px solid #000", whiteSpace: "nowrap" }}
              >
                {responseData.paid}
              </td>
            </tr>
          </tbody>
        </table>

        <table className="second_table">
          <thead>
            <tr style={{ borderRight: "1px solid #000" }}>
              <th
                style={{ width: "75%" }}
                rowSpan={3}
                className="left_line small_letter Under"
              >
                <b className="mx-5">Declaration:</b>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr style={{ borderRight: "1px solid #000" }}>
              <td className="left_line small_letter final_side">
                Payment can be made via bank transfer,debit card, other agreed
                methods
              </td>
            </tr>
            <tr style={{ borderRight: "1px solid #000" }}>
              <td className="left_line small_letter final_side text-justify">
                We hereby confirm that this invoice accurately reflects the
                actual price of the goods listed and that all details provided
                are true and correct.
              </td>
            </tr>

            <tr>
              <td className="left_line small_letter">
                <b>
                  Contact us :{" "}
                  <span
                    className="text-danger small_letter"
                    style={{ fontSize: "12px" }}
                  >
                    support@skimitarhindusthan.com
                  </span>
                </b>
              </td>
              <td
                className="left_line small_letter text-center text-danger Final_amount"
                style={{ borderRight: "1px solid #000" }}
              >
                <b>Seal & Signature</b>
              </td>
            </tr>

            <tr style={{ borderRight: "1px solid #000" }}>
              <td
                className="small_letter up"
                style={{ borderLeft: "1px solid #000" }}
              >
                <b>
                  More Details :{" "}
                  <span
                    className="text-danger small_letter"
                    style={{ fontSize: "12px" }}
                  >
                    www.skimitarhindusthan.com
                  </span>
                </b>
              </td>
            </tr>
            <tr style={{ borderRight: "1px solid #000" }}>
              <td
                className="small_letter final_side"
                style={{ borderLeft: "1px solid #000" }}
              >
                <b>
                  Office :{" "}
                  <span
                    className="text-danger small_letter"
                    style={{ fontSize: "11px" }}
                  >
                    {" "}
                   +91-8428010909
                  </span>
                </b>
              </td>
            </tr>
          </tbody>
        </table>

        <table className="third_table">
          <thead className="table_head_third">
            <tr>
              <th className="small_letter text-center">
                <b>Thanks for having training with us!!! best wishes !!!</b>
              </th>
            </tr>
          </thead>
        </table>
      </div>
    </>
  );
}

export default Studentinvoice;